// src/components/Auth/SessionExpiredModal.jsx
import React, { useContext } from 'react';
import AuthContext from '../../context/AuthContext';
import './SessionExpiredModal.css';

const SessionExpiredModal = () => {
    const { showSessionExpiredModal, dismissSessionExpiredModal, redirectToLogin } = useContext(AuthContext);

    if (!showSessionExpiredModal) {
        return null;
    }

    const handleLogin = () => {
        dismissSessionExpiredModal();
        redirectToLogin();
    };

    return (
        <div className="session-expired-overlay">
            <div className="session-expired-modal">
                <div className="session-expired-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <circle cx="12" cy="12" r="10"></circle>
                        <line x1="12" y1="8" x2="12" y2="12"></line>
                        <line x1="12" y1="16" x2="12.01" y2="16"></line>
                    </svg>
                </div>
                <h2>Session Expired</h2>
                <p>Your session has expired. Please log in again to continue.</p>
                <div className="session-expired-actions">
                    <button className="session-login-button" onClick={handleLogin}>
                        Log In
                    </button>
                </div>
            </div>
        </div>
    );
};

export default SessionExpiredModal;